import React from 'react';
import PropTypes from 'prop-types';
// There is a dependancy cycle here from FormSection importing common-logic
/* eslint-disable-next-line import/no-cycle */
import { FormSection } from 'AppSrc/core/components/forms/form-section';
import { prefixStringWithIndexPlusOne } from 'AppSrc/core/utility-functions/string-fun';
import { navigationPropsShape } from 'AppSrc/core/components/forms/section-nav';
import { userRolesPropShape } from 'AppSrc/core/auth/auth-proptypes';
import { getDisplayOptionsToUse } from 'AppSrc/core/components/forms/data/get-display-options-to-use';
// Key values that are repeated a lot
import { defaultFieldLogic } from 'AppSrc/core/components/forms/form-base-components/data-structure/default-field-logic';
import {
  formDataShape,
} from 'AppSrc/core/components/forms/form-base-components/data-structure/v-f-proptypes';
import {
  CHANGE_TYPE,
  SECTION_TITLES,
} from 'AppSrc/core/components/forms/form-types/create-crq/form-definition/section-constants';
import {
  FIXED,
  MOBILE,
  EXPEDITED_FIXED,
  NORMAL_FIXED,
  NORMAL_MOBILE,
  EXPEDITED_MOBILE,
  EMERGENCY_MOBILE,
  EMERGENCY_FIXED,
} from 'AppSrc/core/components/forms/value-dependency-constants';
import { internationalCoordinatorGroups } from 'AppSrc/core/components/forms/form-types/create-crq/section-one/section-one-constants';
import { COORDINATOR } from 'AppSrc/core/components/forms/form-base-components/data-structure/constants';

// form fields
import { selectNetworkParams } from './select-network-params';
import { selectNetworkParamsRequester } from './select-network-params-requester';
// sub section titles
import { sstSelectNetwork } from './sst-select-network';

import { sstSelectChangeSla } from './sst-select-change-sla';
import { selectChangeSla } from './select-change-sla';
import { oloRequiredInternationalServices } from './olo-req-international-ser';
import { oloReqIntTitle } from './olo-req-int-title';


// Section ID (for the data layer)
const sectionId = CHANGE_TYPE;
// Title for the main form
const sectionTitle = SECTION_TITLES[CHANGE_TYPE];


const filterAndSortSlaTypes = ({
  componentData,
  selectedNetwork,
}) => {

  if (!selectedNetwork) {
    return [];
  }

  const allDisplayOptions = getDisplayOptionsToUse({
    componentData,
    selectedNetwork,
  });


  const normalDisplayOption = allDisplayOptions.find((option) => ((option.value === NORMAL_FIXED) || option.value === NORMAL_MOBILE));
  const expeditedDisplayOption = allDisplayOptions.find((option) => ((option.value === EXPEDITED_FIXED) || (option.value === EXPEDITED_MOBILE)));
  const emergencyDisplayOption = allDisplayOptions.find((option) => ((option.value === EMERGENCY_FIXED) || (option.value === EMERGENCY_MOBILE)));

  if (!normalDisplayOption || !expeditedDisplayOption) {
    // this will likely fire if selectChangeSla tries to render without it's dynamically selected display options.
    // ie, it tries to get display options for 'timing' not 'timing-mobile'
    console.warn(`Cannot find "normalDisplayOption" or "expeditedDisplayOption" for ${componentData.id}`);
  }

  const filteredDisplayOptions = [normalDisplayOption, expeditedDisplayOption, emergencyDisplayOption];

  return filteredDisplayOptions;

};

const getTimingFields = ({
  selectedNetwork,
  userRole,
  IsOlaCrq,
}) => {
  // only coordinators can see this section and only if they have mobile selected in the first option
  const showSelectChangeSla = (userRole === COORDINATOR) && IsOlaCrq;
  const selectChangeSlaOWV = selectedNetwork === FIXED ? NORMAL_FIXED : NORMAL_MOBILE;
  const timingFields = [];
  timingFields.push({
    ...defaultFieldLogic,
    componentData: sstSelectChangeSla,
    shouldRender: showSelectChangeSla,
  });
  timingFields.push({
    ...defaultFieldLogic,
    componentData: {
      ...selectChangeSla,
      displayOptions: filterAndSortSlaTypes({
        componentData: selectChangeSla,
        selectedNetwork,
      }),
    },
    shouldRender: showSelectChangeSla,
    shouldValidate: showSelectChangeSla,
    overwriteSubmit: {
      // overwrite: !showSelectChangeSla,
      overwriteValue: [selectChangeSlaOWV],
    },
  });
  return timingFields;
};


// callback for the form section to figure out what fields to render with conditional logic
const getCurrentFields = (params) => {

  const {
    formData = {},
    // touched = {},
    userRoles,
    userGroups,
    values = {},
  } = params;
  // this is only ever true on the very first render of the component if there is no
  // data in redux
  // const FIXED = 'fixed';
  // console.log('userGroups', userGroups, ((userRoles[FIXED] === COORDINATOR || userRoles[MOBILE] === COORDINATOR) && userGroups) ? userGroups[FIXED][0] : null);

  // Here we are checking what is the deafult group of logged in coordinator is!
  const internationalChangeCooridnatorDefaultGroup = ((userRoles[FIXED] === COORDINATOR) && userGroups) ? userGroups[FIXED][0] : null;

  // Here we are verifying if logged in coordinator is International change coordinator or not by checking if their default group is present in the list of International Change coordinator group.
  const isInternationalChangeCoordinator = internationalCoordinatorGroups.includes(internationalChangeCooridnatorDefaultGroup);
  window.localStorage.setItem('isICMCoordinator', isInternationalChangeCoordinator);


  const hasCrqId = formData.crqId ? true : false;

  let selectedNetwork = '';
  let IsOlaCrq = false;
  let isIcmCrq = false;
  // let userRoleNetwork = '';
  if (values && values.select_network && values.select_network[0] && values.select_network[0] === 'fixedOlo') {
    selectedNetwork = 'fixed';
    IsOlaCrq = true;
    // userRoleNetwork = 'fixed';
  }
  else if (values && values.select_network && values.select_network[0] && values.select_network[0] === 'fixedInternational') {
    selectedNetwork = 'fixed';
    isIcmCrq = true;
    // userRoleNetwork = 'fixed';
  }
  else if (values && values.select_network && values.select_network[0] && values.select_network[0]) {
    selectedNetwork = values.select_network[0];
    // userRoleNetwork = values.select_network[0];
  }
  // const IsOlaCrq = getIsOlaCrq(formData);
  // const userRole = userRoleForSelectedNetwork(formData, userRoles);
  const userRole = userRoles ? userRoles[selectedNetwork] : undefined;

  const currentFields = [];
  currentFields.push({
    ...defaultFieldLogic,
    componentData: sstSelectNetwork,
  });
  currentFields.push({
    ...defaultFieldLogic,
    componentData: {
      ...selectNetworkParams,
      displayOptions: getDisplayOptionsToUse({
        componentData: ((userRoles[FIXED] === COORDINATOR || userRoles[MOBILE] === COORDINATOR)) ? selectNetworkParams : selectNetworkParamsRequester,
      }),
    },
    readOnly: hasCrqId,
  });

  // const timingFields = getTimingFields({
  //   selectedNetwork,
  //   userRole,
  // });
  // if (IsOlaCrq) {
  const timingFields = getTimingFields({
    selectedNetwork,
    userRole,
    IsOlaCrq,
    isIcmCrq,
  });
  currentFields.push(...timingFields);
  // }
  // OLO CRQ service international field
  currentFields.push({
    ...defaultFieldLogic,
    componentData: oloReqIntTitle,
    shouldRender: IsOlaCrq,
    shouldValidate: IsOlaCrq,
  });
  currentFields.push({
    ...defaultFieldLogic,
    componentData: oloRequiredInternationalServices,
    shouldRender: IsOlaCrq,
    shouldValidate: IsOlaCrq,
  });

  return currentFields;
};

// generates the formSection!
const SectionOne = React.memo(({
  handleSuccessfulSubmit,
  userRoles,
  formData,
  userGroups,
  navigationProps,
  sectionIndex,
  editingStatus,
}) => {

  // Props for the SectionNav in FormSection. these come from the parent but we mutate them to be relivent to the section
  const filteredNavigationProps = {
    ...navigationProps,
    prev: null,
    submitForm: null,
  };

  const formattedSectionTitle = prefixStringWithIndexPlusOne(sectionTitle, sectionIndex);


  return (
    <FormSection
      sectionTitle={formattedSectionTitle}
      sectionId={sectionId}
      getCurrentFields={getCurrentFields}
      userRoles={userRoles}
      userGroups={userGroups}
      formData={formData}
      navigationProps={filteredNavigationProps}
      handleSuccessfulSubmit={handleSuccessfulSubmit}
      editingStatus={editingStatus}
    />
  );
});


SectionOne.propTypes = {
  handleSuccessfulSubmit: PropTypes.func,
  userRoles: userRolesPropShape,
  userGroups: PropTypes.objectOf(PropTypes.array),
  formData: formDataShape,
  navigationProps: navigationPropsShape,
  sectionIndex: PropTypes.number,
  editingStatus: PropTypes.string,
};

export {
  SectionOne,
  getCurrentFields,
  CHANGE_TYPE,
};
